import { fileFilter } from 'common/help/file';

function handlerDrop(fileRegExp: RegExp, maxSize: number, event: DragEvent) {
  event.preventDefault();
  if (event.type === 'drop') {
    const uploadFiles = fileFilter(
      event.dataTransfer.files,
      fileRegExp,
      maxSize
    );
    const customEvent = new CustomEvent('ng-drop-files', {
      detail: { files: uploadFiles },
    });
    window.dispatchEvent(customEvent);
  }
}

export function dropFileUploaderEffect(
  dropTarget: HTMLElement,
  fileRegExp: RegExp,
  maxSize: number
) {
  if (dropTarget) {
    const _handlerDrop = handlerDrop.bind(null, fileRegExp, maxSize);

    dropTarget.addEventListener('drop', _handlerDrop);
    dropTarget.addEventListener('dragenter', _handlerDrop);
    dropTarget.addEventListener('dragover', _handlerDrop);

    return function() {
      dropTarget.removeEventListener('drop', _handlerDrop);
      dropTarget.removeEventListener('dragenter', _handlerDrop);
      dropTarget.removeEventListener('dragover', _handlerDrop);
    };
  }
  return null;
}
